module.exports = __webpack_public_path__ + "static/BT_logo-94d35114b644a6f99094fc13575f81b6.png";